import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearAuthInfo, setAuthInfo } from "@/redux/auth/auth.slice";
import customerService from "@/service/customer.service";
// import vendorService from "@/service/vender.service";

import vendorService from "@/service/vender.service";


const useInitializeAuth = () => {
    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state.auth);

    useEffect(() => {
        const initializeAuth = async () => {
            const storedAccessToken = localStorage.getItem("access_token");
            const storedRole = localStorage.getItem("role");
            if (storedAccessToken && storedRole) {
                try {
                    // Only call the API if auth._id is null
                    if (!auth?._id) {
                        let userDetails;
                        if (storedRole === "customer") {
                            userDetails = await customerService.fetchCustomerDetails();
                            userDetails.role  =  "customer";
                        } else if (storedRole === "vendor") {
                            userDetails = await vendorService.fetchVendorById();
                            userDetails.role  =  "vendor";
                        } else {
                            console.error("Invalid role detected.");
                            dispatch(clearAuthInfo());
                            return;
                        }
                        userDetails.id = userDetails._id; // Assuming _id is the unique identifier
                        dispatch(setAuthInfo(userDetails));
                    }
                } catch (error) {
                    console.error("Error fetching user details:", error);
                    dispatch(clearAuthInfo());
                }
            } else {
                dispatch(clearAuthInfo());
            }
        };

        initializeAuth();
    }, [dispatch, auth?._id]); // Dependency array includes auth._id

    return auth;
};

export default useInitializeAuth;
